import { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper
} from "@mui/material";
import API from "../services/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    try {
      if (!username || !password) {
        return alert("Completá los campos");
      }

      const res = await API.post("/auth/login", {
        username,
        password
      });

      login(res.data.token);

      window.location.href = "/shop";

    } catch (err) {
      console.log(err);
      alert(err?.response?.data?.message || "Error en login");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: `
          radial-gradient(circle at 50% 0%, rgba(255,110,0,0.15), transparent 40%),
          linear-gradient(180deg, #141414 0%, #2a1208 100%)
        `
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          width: 350,
          background: "rgba(20,20,20,0.9)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255,110,0,0.3)"
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 3,
            color: "#fff",
            textAlign: "center",
            textShadow: "0 0 10px rgba(255,110,0,0.7)"
          }}
        >
          Iniciar Sesión
        </Typography>

        <TextField
          fullWidth
          label="Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          margin="normal"
          InputLabelProps={{ style: { color: "#aaa" } }}
          sx={{
            input: { color: "#fff" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#ff6e00" },
              "&:hover fieldset": { borderColor: "#ffae00" }
            }
          }}
        />

        <TextField
          fullWidth
          label="Contraseña"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
          InputLabelProps={{ style: { color: "#aaa" } }}
          sx={{
            input: { color: "#fff" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#ff6e00" },
              "&:hover fieldset": { borderColor: "#ffae00" }
            }
          }}
        />

        <Button
          fullWidth
          onClick={handleLogin}
          sx={{
            mt: 2,
            py: 1.5,
            fontWeight: "bold",
            background: "linear-gradient(90deg, #ff6e00, #ffae00)",
            color: "#000",
            boxShadow: "0 0 10px rgba(255,110,0,0.6)",
            "&:hover": {
              background: "linear-gradient(90deg, #ffae00, #ff6e00)"
            }
          }}
        >
          Entrar
        </Button>
      </Paper>
    </Box>
  );
}